<script setup lang="ts">
import { computed, useAttrs } from 'vue'

type FontWeight = 'thin' | 'normal' | 'medium' | 'semibold' | 'bold' | 'extrabold'

const props = defineProps<{
  fontWeight?: FontWeight
}>()

const attrs = useAttrs()

const labelClasses = computed(() => [
  'block mb-2 text-sm',
  `font-${props.fontWeight ?? 'medium'}`,
  attrs.class
])
</script>

<template>
  <label :class="labelClasses">
    <slot />
  </label>
</template>
